import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  gap: var(--allie-radius-xl);
  width: 100%;
  container-type: inline-size;
  container-name: cost-general-info;

  @container report-view-grid (max-width: 410px) {
    flex-direction: column;
    row-gap: var(--allie-spacing-md);
  }
`;

export const MetricCard = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-md);
  padding: var(--allie-spacing-lg);
  background: var(--allie-color-white);
  border: 1px solid var(--allie-color-light-60);
  border-radius: var(--allie-radius-xs);
  flex: 1;

  @container report-view-grid (max-width: 610px) {
    flex-direction: column;
    align-items: flex-start;
    row-gap: var(--allie-spacing-md);
  }

  @container report-view-grid (max-width: 410px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  background: var(--allie-color-light-60);
  border-radius: var(--allie-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-xs);
  flex: 1;
`;

export const ValueContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;
